<template>
    <div
        ref="mobilePanel"
        class="mobile-search-panel"
        :class="{ 'is-open': mobileNavStore.getSearchNavState }">
        <div class="form-group">
            <div class="form-control has-icon">
                <button type="button" class="btn-icon" @click="goToSearch(searchQuery)">
                    <svgComponent :width="24" :height="24" icon-name="icon-search"></svgComponent>
                </button>
                <input
                    ref="searchInput"
                    type="text"
                    id="mobileSearch"
                    name="mobileSearch"
                    v-model="searchQuery"
                    @input="handleInput"
                    @keyup.esc="handleClose"
                    @keyup.enter="goToSearch(searchQuery)"
                    placeholder="Zoeken naar..." />
            </div>
            <div class="search-highlights-wrapper">
                <Transition name="show-search">
                    <template
                        v-if="searchStore.error && !searchStore.loading && searchQuery.length > 3">
                        <div class="search-highlights">
                            <template v-if="cSearchSuggestions?.length === 0">
                                <h4>Geen resultaten</h4>
                                <h5>Probeer een andere zoekterm</h5>
                            </template>
                            <template v-else>
                                <h4>Er is iets mis gegaan</h4>
                            </template>
                        </div>
                    </template>
                    <template
                        v-else-if="
                            cSearchSuggestions != undefined &&
                            !searchStore.loading &&
                            cSearchSuggestions?.length > 0
                        ">
                        <div class="search-highlights">
                            <a
                                :href="`/search?query=${item}`"
                                class="item h5"
                                v-for="(item, index) in cSearchSuggestions"
                                :key="`suggestion-${index}`"
                                v-html="useHighlight(item, searchQuery)"></a>
                        </div>
                    </template>
                </Transition>
            </div>
        </div>
        <section class="popular-panel">
            <popular-grid title="Populaire onderwerpen"></popular-grid>
        </section>
    </div>
</template>

<script setup lang="ts">
import { useDebounceFn, onClickOutside } from '@vueuse/core';
import { useHighlight } from '../../../composables/useHighlight';
import { ref, computed, watch } from 'vue';
import svgComponent from '../../../components/svgComponent.vue';
import { useMobileNavStore } from '../store/mobile-nav.store';
import { useSearchStore } from '../../../stores/search.store';
import popularGrid from './popular-grid.component.vue';

const mobileNavStore = useMobileNavStore();
const searchStore = useSearchStore();

const mobilePanel = ref<HTMLDivElement | null>(null);
const searchInput = ref<HTMLInputElement | null>(null);
const searchQuery = ref<string>('');

const cSearchPanelState = computed(() => {
    return mobileNavStore.getSearchNavState;
});

const cSearchSuggestions = computed(() => {
    return searchStore.getSearchSuggestions;
});

onClickOutside(mobilePanel, () => {
    if (mobileNavStore.getSearchNavState) {
        handleClose();
    }
});

const goToSearch = (query: string) => {
    searchStore.setSearchQuery(query);
    window.location.href = `/search?query=${searchStore.query}`;
};

const handleClose = () => {
    mobileNavStore.toggleSearchNav();
    searchStore.clearSearchSuggestions();
    searchQuery.value = '';
};

const handleInput = useDebounceFn(() => {
    if (searchQuery.value.length > 3) {
        searchStore.fetchSearchSuggestions(searchQuery.value);
    } else {
        searchStore.clearSearchSuggestions();
    }
}, 500);

watch(cSearchPanelState, (openState) => {
    if (openState) {
        searchInput.value?.focus();
    } else {
        searchInput.value?.blur();
    }
});
</script>
